var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCarAccident = function SvgCarAccident(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#EC008C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.933,
    d: "m6.213 18.484 3.241 1.103a.97.97 0 0 0 .658-.012l10.172-3.907a.97.97 0 0 0 .498-.43l1.67-2.99M11.448 22.684l.009-.003m9.915-3.808.009-.003M9.656 13.539l6.927-2.66a1.93 1.93 0 0 1 1.916.307l4.37 3.57c.52.425.922.98 1.163 1.608l2.057 5.356a.966.966 0 0 1-.555 1.249l-.903.346a.966.966 0 0 1-1.248-.555l-.347-.902-10.826 4.157.347.902a.966.966 0 0 1-.556 1.249l-.902.346a.966.966 0 0 1-1.248-.555L7.793 22.6a3.87 3.87 0 0 1-.212-1.973l.857-5.578a1.93 1.93 0 0 1 1.218-1.51M11.9 22.51a.483.483 0 1 1-.902.347.483.483 0 0 1 .902-.347m9.924-3.81a.483.483 0 1 1-.903.346.483.483 0 0 1 .903-.347"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EC008C",
    d: "m18.163 7.894-.724-3.039L19.48 6.23 22 3l-.438 4.076 2.156.148-1.44 1.612 2.729 1.556-3.078.226zM10.6 28h16v1.54h-16z"
  })));
};
export default SvgCarAccident;